import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './i18n/i18n';
import './styles/global.css';  // ← add this

import App from './App';
import './styles.css';
import './styles/global.css'; // ← ADD THIS

const container = document.getElementById('root');
const root = createRoot(container);
root.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>
);